import colors from 'shared-tokens/utils/tokens/colors';

export const mainCls = 'select-list-cnt';

export default {
  [mainCls]: {
    position: 'absolute',
    top: '100%',
    right: 0,
    zIndex: 4,
    width: 'auto',
    height: 0,
    overflow: 'hidden',
  },
  [`${mainCls}--open`]: {
    height: 'auto',
    background: colors.w.rgba,
    borderRadius: '4px',
    border: 'solid 1px #96a1b0',
  },
  [`${mainCls}--li-item`]: {
    background: colors.w.rgba,
  },
  [`${mainCls}--item-btn`]: {
    display: 'flex',
    cursor: 'pointer',
    border: 'none',
    alignItems: 'center',
    margin: 0,
    padding: '0 10px',
    width: '100%',
    fontSize: 14,
    color: colors.f2.rgba,
    backgroundColor: 'transparent',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: colors.secondary.rgba,
    },
    '& span': {
      paddingRight: 8,
    },
    '& svg': {
      marginTop: -2,
    },
  },
  [`${mainCls}--item-btn-selected`]: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    backgroundColor: colors.bg.rgba,
    color: colors.f0.rgba,
  },
  [`${mainCls}--icon-ghost`]: {
    width: '12px',
    height: '12px',
  },
};
